import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, Stack, Card } from '@mui/material';
import {
    Datagrid,
    DateField,
    FunctionField,
    ListBase,
    TextField,
    Title,
    CreateButton,
    ListToolbar,
    TopToolbar,
} from 'react-admin';
import type { HighlightedResourceLight } from '@wwf/sdk';
import { useHighlightedResourceDrawer } from '../drawer/HighlightedResourceDrawer';

export const HighlightedResourceList = () => {
    return (
        <ListBase
            resource="highlightedResource"
            perPage={50}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <HighlightedResourceListView />
        </ListBase>
    );
};

const HighlightedResourceListView = () => {
    const { openDrawer } = useHighlightedResourceDrawer();

    return (
        <Stack sx={{ width: '100%' }}>
            <Title title={'highlighted resource'} />
            <ListToolbar
                actions={
                    <HighlightedResourceListActions
                        openCreateDrawer={() => openDrawer('create', null)}
                    />
                }
            />

            <Card>
                <Datagrid
                    bulkActionButtons={false}
                    rowClick={id => {
                        openDrawer(
                            'show',
                            id as HighlightedResourceLight['id']
                        );
                        return false;
                    }}
                >
                    <TextField source="name" />
                    <FunctionField<HighlightedResourceLight>
                        label="URL"
                        render={record =>
                            record?.url ? (
                                <Link
                                    href={`${record.url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    underline="hover"
                                    onClick={e => e.stopPropagation()}
                                    sx={{
                                        maxWidth: 520,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 0.75,
                                    }}
                                >
                                    <span
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {record.url}
                                    </span>
                                    <OpenInNewIcon fontSize="inherit" />
                                </Link>
                            ) : (
                                '—'
                            )
                        }
                    />
                    <DateField source="createdAt" showTime />
                </Datagrid>
            </Card>
        </Stack>
    );
};

const HighlightedResourceListActions = ({
    openCreateDrawer,
}: {
    openCreateDrawer: () => void;
}) => (
    <TopToolbar>
        <CreateButton
            variant="contained"
            label="New Highlighted Resource"
            onClick={openCreateDrawer}
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
